export default __webpack_public_path__ + "static/media/rodrigo_salas_guzman.a7211865.jpeg";